import { ModalComponent } from '../ModalComponent/ModalComponent'
import { ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { TextPage } from '../../TextPage/TextPage';
import './ModalWarning.scss'

const ModalWarning = ({
    headerText,
    messageText,
    children = null,
    approveButtonText,
    onApproveClick,
    cancelButtonText,
    onCancelClick,
    colorBtn = 'green',
    disabledApprove = false
}) => {

    return (
        <ModalComponent
            onClose={onCancelClick}
            title={headerText}
            style={{
                height: 'auto',
                maxWidth: '500px'
            }}
            child={
                <div className='modal-warning modal-password-changed'>
                    {messageText && <TextPage
                        text={messageText}
                    />}
                    {children}
                    <div className='modal-warning__buttons-container'>
                        <ButtonBasic
                            grey
                            onClick={onCancelClick}
                            text={cancelButtonText}
                            width={'calc(100% - 6px)'}
                        />
                        
                        <ButtonBasic
                            green={colorBtn === 'green'}
                            red={colorBtn === 'red'}
                            onClick={onApproveClick}
                            text={approveButtonText}
                            width={'calc(100% - 6px)'}
                            disabled={disabledApprove}
                        />
                    </div>
                </div>
            }
        />

    )
}

export default ModalWarning
